class PlotScatter extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let {
      data,
      scaleX,
      scaleY,
      getX,
      getY,
      getZ,
      color,
      stroke,
      opacity,
      image,
      size
    } = this.props;

    let points = d3.select(this.refs.points);
    let disciminator = (d, i) => [getX(d, i), getY(d)].toString();

    if (image) {
      points = points
        .selectAll("image")
        .data(data, disciminator);

      points
        .exit()
        .remove();

      points = points
        .enter()
        .append("image")
        .merge(points)
        .attr("xlink:href", image)
        .attr("x", (d, i) => scaleX(getX(d, i)))
        .attr("y", (d) => scaleY(getY(d)))
        .attr("transform", `translate(${size / -2},${size / -2})`)
        .attr("width", size)
        .attr("height", size)
        .attr("opacity", opacity);
    }
    else {
      points = points
        .selectAll("circle")
        .data(data, disciminator);

      points
        .exit()
        .remove();

      points = points
        .enter()
        .append("circle")
        .merge(points)
        .attr("cx", (d, i) => scaleX(getX(d, i)))
        .attr("cy", (d) => scaleY(getY(d)))
        .attr("r", (d) => (size / 2) * (getZ ? Math.sqrt(getZ(d)) : 1))
        .attr("data-x", (d, i) => getX(d, i))
        .attr("data-y", getY)
        .attr("data-z", getZ)
        .attr("data-tooltip", getZ)
        .attr("fill", color)
        .attr("stroke", stroke ? color : null)
        .attr("stroke-width", stroke)
        .attr("fill-opacity", opacity);
    }

    points
      .attr("data-x", getX)
      .attr("data-y", getY);
  }

  render() {
    return (
      <g className="mc-plot-scatter" ref="points">
      </g>
    );
  }
}

PlotScatter.defaultProps = {
  size: 6,
  color: "#304561",
  opacity: 1,
  stroke: null,
  image: null,
  getZ: null
};

module.exports = PlotScatter;